import { render } from "./ListItem.vue?vue&type=template&id=d871da2e&scoped=true&ts=true"
import script from "./ListItem.vue?vue&type=script&lang=ts"
export * from "./ListItem.vue?vue&type=script&lang=ts"

import "./ListItem.vue?vue&type=style&index=0&id=d871da2e&scoped=true&lang=less"

import exportComponent from "D:\\wamp\\UF\\uf-approve-h5\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d871da2e"]])

export default __exports__